import React from 'react';
import { Link } from 'react-router-dom';
import DemoCTA from '../ui/DemoCTA';

const Footer = () => {
  return (
    <>
      <DemoCTA />
      <footer className="footer py-5">
        <div className="container">
          <div className="row mb-4">
            <div className="col-12 col-md-2 mb-4 mb-md-0">
              <h5 className="fw-bold mb-3">Platform</h5>
              <ul className="list-unstyled">
                {/* <li>
                  <a href="#">Platform Overview</a>
                </li> */}
                <li>
                  <Link to="/platform/website-ai-chatbot">Website AI Chatbot</Link>
                </li>
                <li>
                  <Link to="/platform/whatsapp-integration">WhatsApp Integration</Link>
                </li>
                {/* <li>
                  <a href="#">Flow Builder</a>
                </li>
                <li>
                  <a href="#">Campaign Automation</a>
                </li>
                <li>
                  <a href="#">CRM/API Integration</a>
                </li>
                <li>
                  <a href="#">Real-Time Analytics</a>
                </li>
                <li>
                  <a href="#">Security</a>
                </li> */}
              </ul>
            </div>

            <div className="col-12 col-md-2 mb-4 mb-md-0">
              <h5 className="fw-bold mb-3">Features</h5>
              <ul className="list-unstyled">
                <li>
                  <Link to="/features/lead-generation">Lead Generation</Link>
                </li>
                <li>
                  <Link to="/features/support-automation">Support Automation</Link>
                </li>
                <li>
                  <Link to="/features/ai-campaigns">AI Campaigns</Link>
                </li>
              </ul>
            </div>

            <div className="col-12 col-md-2 mb-4 mb-md-0">
              <h5 className="fw-bold mb-3">Industries</h5>
              <ul className="list-unstyled">
                <li>
                  <Link to="/industries/b2c-d2c-brands">B2C & D2C Brands</Link>
                </li>
                <li>
                  <Link to="/industries/hospitality">Hospitality & Resorts</Link>
                </li>
                <li>
                  <Link to="/industries/education">Education & EdTech</Link>
                </li>
                {/* <li>
                  <a href="#">Healthcare & Clinics</a>
                </li>
                <li>
                  <a href="#">Retail & E-commerce</a>
                </li>
                <li>
                  <a href="#">SaaS & Startups</a>
                </li> */}
              </ul>
            </div>

            <div className="col-12 col-md-2 mb-4 mb-md-0">
              <h5 className="fw-bold mb-3">Company</h5>
              <ul className="list-unstyled">
                <li>
                  <Link to="/about">About Us</Link>
                </li>
                <li>
                  <Link to="/pricing">Pricing</Link>
                </li>
                <li>
                  <Link to="/contact">Contact</Link>
                </li>
                {/* <li>
                  <Link to="/partners">Partner Program</Link>
                </li> */}
                {/* <li>
                  <Link to="/careers">Careers</Link>
                </li> */}
                {/* <li>
                  <Link to="/press">Press</Link>
                </li> */}
                <li>
                  <Link to="/sitemap">Sitemap</Link>
                </li>
              </ul>
            </div>
            <div className="col-12 col-md-2 mb-4 mb-md-0">
              <h5 className="fw-bold mb-3">Integrations</h5>
              <ul className="list-unstyled">
                <li>
                  <a href="https://blog.aichatassist.com" target="_blank" rel="noopener noreferrer">
                    WhatsApp Business
                  </a>
                </li>
                <li>
                  <a href="https://blog.aichatassist.com" target="_blank" rel="noopener noreferrer">
                    HubSpot
                  </a>
                </li>
                <li>
                  <a href="https://blog.aichatassist.com" target="_blank" rel="noopener noreferrer">
                    Zoho
                  </a>
                </li>
                <li>
                  <a href="https://blog.aichatassist.com" target="_blank" rel="noopener noreferrer">
                    Google Sheets
                  </a>
                </li>
                <li>
                  <a href="https://blog.aichatassist.com" target="_blank" rel="noopener noreferrer">
                    Meta Ads
                  </a>
                </li>
              </ul>
            </div>
            <div className="col-12 col-md-2 mb-4 mb-md-0">
              <h5 className="fw-bold mb-3">Resources</h5>
              <ul className="list-unstyled">
                <li>
                  <a href="https://blog.aichatassist.com" target="_blank" rel="noopener noreferrer">Blog</a>
                </li>
                {/* <li>
                  <a href="#">ROI Calculator</a>
                </li>
                <li>
                  <a href="#">Case Studies</a>
                </li>
                <li>
                  <a href="#">Webinars</a>
                </li>
                <li>
                  <a href="#">Community</a>
                </li>
                <li>
                  <a href="#">Knowledge Base</a>
                </li> */}
              </ul>
            </div>
          </div>

          <hr className="my-4" />

          <div className="row align-items-center">
            <div className="col-md-1 mb-3 mb-md-0">
              <Link to="/" className="text-decoration-none">
                <div className="d-flex align-items-center text-decoration-none mb-4">
                  <img src="images/logo.png" className="logo me-2" alt="Logo" />
                </div>
              </Link>
            </div>
            <div className="col-md-3 text-center text-md-end">
              <Link to="/terms" className="text-muted me-3" style={{ textDecoration: 'none' }}>
                Terms of Service
              </Link>

            </div>
            <div className="col-md-5 text-center text-md-center mb-3 mb-md-0">
              <p className="text-muted mb-0">
                &copy; 2010-2025 OIT Technology Pvt. Ltd. All rights reserved.
              </p>
            </div>

            <div className="col-md-3 text-center text-md-end">
              <div className="d-flex justify-content-center justify-content-md-end gap-3">
                <a href="https://x.com/Ai_assist_chat_" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <i className="bi bi-twitter"></i>
                </a>
                <a href="https://www.facebook.com/openinfotech/" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <i className="bi bi-facebook"></i>
                </a>
                <a href="https://instagram.com/aichatassist" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <i className="bi bi-instagram"></i>
                </a>
                <a href="https://www.linkedin.com/company/ai-chat-assist" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <i className="bi bi-linkedin"></i>
                </a>
                <a href="https://www.youtube.com/@AIChatAssist" target="_blank" rel="noopener noreferrer" className="social-icon">
                  <i className="bi bi-youtube"></i>
                </a>
              </div>
            </div>
          </div>

          <div className="row mt-4">
            <div className="col-12 text-center">
              <p className="text-muted mb-0 built-with-love">
                Built with <i className="bi bi-heart-fill text-danger mx-1"></i> in Pune
              </p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
